import React from 'react';
import { useTranslation } from 'react-i18next';
import { Bot } from 'lucide-react';

const TypingIndicator = () => {
  const { t } = useTranslation();

  return (
    <div className="ai-tutor-typing" aria-label={t('aiTutoring.thinking')} role="status">
      <div className="ai-tutor-typing-avatar" aria-hidden>
        <Bot size={16} />
      </div>
      <div className="ai-tutor-typing-bubble">
        <span className="ai-tutor-typing-label">{t('aiTutoring.thinking')}</span>
        <div className="ai-tutor-typing-dots">
          <div className="ai-tutor-typing-dot" />
          <div className="ai-tutor-typing-dot" />
          <div className="ai-tutor-typing-dot" />
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;